import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "Which Media";
const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://which-media.com").replace(/\/$/, "");
const DEFAULT_IMAGE = `${SITE_URL}/logos/whichmedia-white2.png`;
const DEFAULT_DESC =
  "Which Media is the home of Education Intelligence — the trusted group behind WhichSchoolAdvisor.com, SchoolsCompared.com, Top Schools Awards, EdinformaPlus, the Education Intelligence Group and WhichUniversityAdvisor.com.";

/**
 * Reusable SEO / social component.
 * Injects <title>, meta description, canonical, Open Graph, Twitter card,
 * plus optional JSON-LD structured data.
 */
const Seo = ({
  title,
  description = DEFAULT_DESC,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
  jsonLd,
}) => {
  const fullTitle = title ? `${title} · ${SITE_NAME}` : `${SITE_NAME} — Education Intelligence Group`;
  const url = `${SITE_URL}${path}`;
  const ldItems = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {ldItems.map((obj, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
};

export const SITE_ORIGIN = SITE_URL;
export default Seo;
